import { ChangeDetectorRef, Type, inject } from "@angular/core";
import { CwtTranslatable, getId } from "@cawita/core-front";
import { CwtRequestConfig, CwtSubCrudContract, CwtSubCrudService } from "@cawita/core-front/api";
import { CwtNzMessageService } from "@cawita/core-front/zorro";
import { EMPTY, Observable, finalize, tap } from "rxjs";

export type SubCrudResourceOptions<T, P = any> = {
    model: Type<T>,
    parent: Type<P>,
    identifier?: string,
    updatedMessage: (item: T) => CwtTranslatable,
    createdMessage: (item: T) => CwtTranslatable,
    deletedMessage: (item: T) => CwtTranslatable,
}

export class SubCrudResource<T, P = any> {
    protected alert = inject(CwtNzMessageService);
    protected cdRef = inject(ChangeDetectorRef);
    protected crud = inject<CwtSubCrudService<T>>(CwtSubCrudContract.get(this.options.model, this.options.parent, this.options.identifier));
    public loading = false;

    constructor(protected options?: SubCrudResourceOptions<T, P>) { }

    public save(parent: P, item: T | null, payload: any, config?: CwtRequestConfig): Observable<T> {
        let obs: Observable<T>;
        if (item) obs = this.crud.update(getId(parent), getId(item), payload, config);
        else obs = this.crud.create(getId(parent), payload, config);

        this.loading = true;
        return obs.pipe(
            finalize(() => {
                this.loading = false;
                this.cdRef.markForCheck();
            }),
            tap(newItem => {
                const msg = item ? this.options.updatedMessage(newItem) : this.options.createdMessage(newItem);
                this.alert.success(msg);
            })
        );
    }

    public delete(parent: P, item: T | null, config?: CwtRequestConfig): Observable<any> {
        if (!item) return EMPTY;
        this.loading = true;
        return this.crud.delete(getId(parent), getId(item), config).pipe(
            finalize(() => {
                this.loading = false;
                this.cdRef.markForCheck();
            }),
            tap(() => {
                const msg = this.options.deletedMessage(item);
                this.alert.success(msg);
            })
        );
    }
}